module.exports = __webpack_public_path__ + "static/105038339_662804997911141_1262601661204406930_o_optimized-ce0c5c7054217c3da87f232ab107e6d6.jpg";